export const WireIcon = ({
  strokeColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none">
    <g clipPath="url(#clip0_2945_59572)">
      <path
        d="M15.8322 10.6445C15.8322 13.2245 13.7455 15.3112 11.1655 15.3112L11.8655 14.1445"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.16553 5.3112C1.16553 2.7312 3.25219 0.644531 5.83219 0.644531L5.13219 1.8112"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8322 8.00132C13.8322 10.9489 11.4465 13.3346 8.49884 13.3346C5.55126 13.3346 3.16553 10.9489 3.16553 8.00132C3.16553 5.05373 5.55126 2.66797 8.49884 2.66797C8.63715 2.66797 8.76681 2.67663 8.91375 2.68527C11.5329 2.88408 13.6247 4.97594 13.8235 7.59505C13.8235 7.72471 13.8322 7.85437 13.8322 8.00132Z"
        stroke={strokeColor}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.83301 9.16877C6.83301 9.81544 7.33302 10.3354 7.94635 10.3354H9.19967C9.733 10.3354 10.1663 9.88211 10.1663 9.31544C10.1663 8.70877 9.89968 8.48878 9.50635 8.34878L7.49967 7.64877C7.10634 7.50877 6.83968 7.29544 6.83968 6.68211C6.83968 6.12211 7.273 5.66211 7.80634 5.66211H9.05967C9.67301 5.66211 10.173 6.18211 10.173 6.82878"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.49854 5V11"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2945_59572">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
